module.exports = __webpack_public_path__ + "static/media/hp_logo.cedf2b9f.png";